import { useEffect } from 'react'

import $api from '../API'
import { useAppDispatch } from '../store'
import { setCommit } from '../store/app/app'

export function CommitSetter(): null {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handle = $api.interceptors.response.use(response => {
      const ref = response.headers['build-commit-ref'] || null
      const date = response.headers['build-commit-date'] || null

      if (ref || date) {
        dispatch(setCommit({ ref, date }))
      }

      return response
    })

    return () => {
      $api.interceptors.response.eject(handle)
    }
  }, [dispatch])

  useEffect(() => {
    const originalFetch = window.fetch

    window.fetch = async (...args) => {
      const response = await originalFetch(...args)

      const ref = response.headers.get('build-commit-ref')
      const date = response.headers.get('build-commit-date')

      if (ref || date) {
        dispatch(setCommit({ ref, date }))
      }
      return response
    }

    return () => {
      window.fetch = originalFetch
    }
  }, [dispatch])

  return null
}
